import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "lucide-react";
import { cn } from "@/lib/utils";

interface BadgeCardProps {
  title: string;
  description: string;
  iconUrl?: string | null;
  isAwarded: boolean;
  awardedAt?: string;
}

/**
 * BadgeCard Component
 * Display a single badge with its status (awarded or not)
 */
export default function BadgeCard({
  title,
  description,
  iconUrl,
  isAwarded,
  awardedAt,
}: BadgeCardProps) {
  return (
    <Card
      className={cn(
        "transition-all hover:shadow-md",
        isAwarded ? "border-primary bg-primary/5" : "opacity-60 grayscale"
      )}
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          {/* Badge Icon */}
          <div
            className={cn(
              "flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center",
              isAwarded ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"
            )}
          >
            {iconUrl ? (
              <img src={iconUrl} alt={title} className="w-8 h-8 object-contain" />
            ) : (
              <Badge className="w-6 h-6" />
            )}
          </div>

          {/* Badge Info */}
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-sm mb-1">{title}</h3>
            <p className="text-xs text-muted-foreground line-clamp-2">{description}</p>

            {isAwarded && awardedAt && (
              <p className="text-xs text-primary mt-2">
                ✓ Obtenu le {new Date(awardedAt).toLocaleDateString()}
              </p>
            )}

            {!isAwarded && (
              <p className="text-xs text-muted-foreground mt-2 italic">Non obtenu</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

